<template>

	<div class="container main-content">	
		<div class="row mb-5">
			<div class="col-12 text-center">
				<h4 class="highlight">Tell us about yourself</h4>
				<div class="row">
					<div class="col-sm-12 offset-lg-2 col-lg-8 offset-xl-3 col-xl-6">
						<div class="form-row">
							<div class="form-group col-sm-12 col-lg-6">
								<input-base v-model="in_buyerInfo.firstName" 
									placeholder="First Name" 
									:isProcessing="isProcessing"
									v-bind:focus="true"
									inputclass="fname"
									:errorinfo="errors.firstName">
								</input-base>
							</div>
							<div class="form-group col-sm-12 col-lg-6">
								<input-base v-model="in_buyerInfo.lastName" 
									placeholder="Last Name" 
									:isProcessing="isProcessing"
									inputclass="lname"
									:errorinfo="errors.lastName">
								</input-base>
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-sm-12">
								<input-base v-model="in_buyerInfo.email" 
									placeholder="Email Address" 
									:isProcessing="isProcessing"
									inputclass="email"
									:errorinfo="errors.email">
								</input-base>
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-sm-12 col-md-6">
								<input-phone v-model="in_buyerInfo.mobile" 
									placeholder="Mobile"
									:isProcessing="isProcessing"
									inputclass="mobile"
									:fiatCurrency="pq.fiatCurrency"
									:phoneinfo="phoneinfo"
									:errorinfo="errors.mobile">
								</input-phone>
							</div>
							<div class="form-group col-sm-12 col-md-6">
								<input-date-of-birth v-model="in_buyerInfo.dateOfBirth" 
									:isProcessing="isProcessing"
									inputclass="dob"
									:errorinfo="errors.dateOfBirth">
								</input-date-of-birth>
							</div>
						</div>
						<template v-if="$gstate.requiresAddressInput()">
						<div class="form-row">
							<div class="form-group col-sm-12">
								<input-base v-model="in_buyerInfo.addressLine1" 
									placeholder="Address" 
									:isProcessing="isProcessing"
									inputclass="addressLine1"
									:errorinfo="errors.addressLine1">
								</input-base>
							</div>
						</div>
						<div class="form-row">
							<div class="form-group col-sm-12 col-md-4">
								<input-base v-model="in_buyerInfo.cityTown" 
									placeholder="City"
									:isProcessing="isProcessing"
									inputclass="cityTown"
									:errorinfo="errors.cityTown">
								</input-base>
							</div>
							<div id="provSelect" class="form-group col-sm-12 col-md-5">
								
								<select ref="provSelect" :disabled="isProcessing" class="form-control provSelectDefault" v-model="in_buyerInfo.stateProv" @change="onSelectChange($event)">
									<option disabled value="">Select {{ getProvinceLabel }}</option>
									<template v-if="$gstate.getActiveCountry() == 'AU'">
									<option value="QLD">Queensland</option>
									<option value="NSW">New South Wales</option>
									<option value="ACT">Australian Capital Territory</option>
									<option value="VIC">Victoria</option>
									<option value="TAS">Tasmania</option>
									<option value="NT">Northern Territory</option>
									<option value="SA">South Australia</option>
									<option value="WA">Western Australia</option>
									</template>
									<template v-else>
									<option value="AB">Alberta</option>
									<option value="BC">British Columbia</option>
									<option value="MB">Manitoba</option>
									<option value="NB">New Brunswick</option>
									<option value="NL">Newfoundland and Labrador</option>
									<option value="NT">Northwest Territories</option>
									<option value="NS">Nova Scotia</option>
									<option value="NU">Nunavut</option>
									<option value="ON">Ontario</option>
									<option value="PE">Prince Edward Island</option>
									<option value="QC">Quebec</option>
									<option value="SK">Saskatchewan</option>
									<option value="YT">Yukon</option>
									</template>

								</select>
								<small class="error" style="position: absolute; top: 42px; text-style: center; width: 100%">{{errors.stateProv.msg}}</small>
								
							</div>
							<div class="form-group col-sm-12 col-md-3">
								<input-base v-model="in_buyerInfo.postalCode" 
									:placeholder="getPostalCodeLabel"
									:isProcessing="isProcessing"
									inputclass="postalCode"
									:errorinfo="errors.postalCode">
								</input-base>
							</div>
						</div>
						</template>
						
					</div>
					<div class="col-sm-12 col-lg-3"></div>
				</div>
				
			</div>
		</div>
		<div class="row">
			<div class="col-12 text-center">
				<a href="#" id="buyer-info-next" class="btn next-btn" v-on:click.prevent="storeBuyerInfo" v-if="!isProcessing">NEXT</a>
				<a href="#" class="btn next-btn disabled" v-on:click.prevent="noop" v-if="isProcessing">PLEASE WAIT... <i class="fas fa-circle-notch fa-spin"></i></a>
			</div>
		</div>

		<cc-modal v-if="showModal" v-bind:confirm="false" @action="modalAction" no="Close">
			<p slot="body">{{ modalMessage }}</p>
		</cc-modal>
	</div>

</template>

<script>

import { ErrorsContainer, BuyerInfo } from './../helpers/utils.js'

import { eventBus } from './../main'

export default {
	data() {
		return {
			isProcessing: false,
			in_buyerInfo: new BuyerInfo(),
			phoneinfo: {},
			errors: new ErrorsContainer(),
			modalMessage: '',
			modalErrorCode: '',
			showModal: false,
			pq: this.$gstate.getFlowState()
		}
	},
	computed: {
		getPostalCodeLabel(){
			if(this.$gstate.getActiveCountry() == 'CA'){
				return 'Postal code';
			} else {
				return 'Postcode';
			}
		},
		getProvinceLabel(){
			if(this.$gstate.getActiveCountry() == 'CA'){
				return 'Province';
			} else {
				return 'State';
			}
		}
	},
	created() {

		eventBus.$on('nextScreen', this.storeBuyerInfo);
		this.in_buyerInfo.stateProv = '';

		var errorsContainer = new ErrorsContainer();
		errorsContainer.addPropsFromModelObj(this.in_buyerInfo);
		this.errors = errorsContainer;

		// check for refid
		if(this.$route.query.refId == null){
			
			// normal flow.  let's verify if the pq is set properly.  if not, kick out
			if(this.pq == undefined || this.pq.fiatCurrency == undefined){
				// go back to homepage
				this.$gstate.redirectHome();
			}

		} else {
			// okay, we have a refid so we're coming from external
			//check if refid is good. if it is, save it!
			this.getTransaction(this.$route.query.refId);
		}

	},
	beforeDestroy(){
		eventBus.$off('nextScreen', this.storeBuyerInfo);
	},
	methods: {
		onSelectChange() {
			this.$refs["provSelect"].style.color = "#000";	// help with styling the province dropdown
			this.$refs["provSelect"].style.borderBottom = "1px solid #000";
			this.errors.stateProv = '';
		},
		storeBuyerInfo: function() {

			this.errors.clearAll();
			
			if (!this.in_buyerInfo.firstName) {
				this.errors.firstName.setError('First Name required');
			} else if (this.in_buyerInfo.firstName.trim().length < 2) {
				this.errors.firstName.setError('First Name must be longer than 1 character');
			}

			if (!this.in_buyerInfo.lastName) {
				this.errors.lastName.setError('Last Name required');
			} else if (this.in_buyerInfo.lastName.trim().length < 2) {
				this.errors.lastName.setError('Last Name must be longer than 1 character');
			}

			if (this.in_buyerInfo.email) {
				var mailformat = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
				if (!this.in_buyerInfo.email.match(mailformat)) {
					this.errors.email.setError('Invalid email address');
				}
			}
			else {
				this.errors.email.setError('Email Address required');
			}

			
			// don't validate phone if debug because it doesn't like my prefilled in phone number
			if (!this.phoneinfo.isValid) {
				if(this.phoneinfo.errorMsg){
					this.errors.mobile.setError(this.phoneinfo.errorMsg);
				} else {
					this.errors.mobile.setError('Mobile must be a valid ' + this.$gstate.getActiveCountry() + ' phone number');
				}
			} 

			if (!this.in_buyerInfo.dateOfBirth.isValid) {
				if(this.in_buyerInfo.dateOfBirth.errorMsg){
					this.errors.dateOfBirth.setError(this.in_buyerInfo.dateOfBirth.errorMsg);
				} else {
					this.errors.dateOfBirth.setError('Birthday is invalid');
				}
			}
			var addressData = {};

			if(this.$gstate.requiresAddressInput()){
				if (!this.in_buyerInfo.addressLine1) {
					this.errors.addressLine1.setError('Address required');
				} else if (this.in_buyerInfo.addressLine1.trim().length < 2) {
					this.errors.addressLine1.setError('Address must be longer than 1 character');
				}

				if (!this.in_buyerInfo.cityTown) {
					this.errors.cityTown.setError('City required');
				} else if (this.in_buyerInfo.cityTown.trim().length < 2) {
					this.errors.cityTown.setError('City must be longer than 1 character');
				}

				if (!this.in_buyerInfo.stateProv) {
					if(this.$gstate.getActiveCountry() == 'CA'){
						this.errors.stateProv.setError('Province required');
					} else {
						this.errors.stateProv.setError('State required');
					}
					
					this.$refs["provSelect"].style.borderBottom = "1px solid #dc3545";
				}

				if (!this.in_buyerInfo.postalCode) {
					this.errors.postalCode.setError('Postal code required');
				} else if (this.$gstate.getActiveCountry() == 'CA' && this.in_buyerInfo.postalCode.replace(/\s/g, "").length != 6) {
					this.errors.postalCode.setError('Postal code must be 6 characters long');
				} else if (this.$gstate.getActiveCountry() == 'AU' && this.in_buyerInfo.postalCode.replace(/\s/g, "").length != 4) {
					this.errors.postalCode.setError('Postcode must be 4 characters long');
				}

				addressData = {
					addressLine1: this.in_buyerInfo.addressLine1.trim(),
					cityTown: this.in_buyerInfo.cityTown.trim(),
					stateProv: this.in_buyerInfo.stateProv.trim(),
					postalCode: this.in_buyerInfo.postalCode.replace(/\s/g, ""),
					country: 'CA'
				}
			}
			
			if (this.errors.count > 0) {
				return;
			}
			
			var buyerInfo = {
				refId: this.$gstate.getRefId(),
				firstName: this.in_buyerInfo.firstName.trim(),
				lastName: this.in_buyerInfo.lastName.trim(),
				emailAddress: this.in_buyerInfo.email.trim(),
				mobile: {
					countryCode: this.phoneinfo.countryCallingCode,
					areaCode: this.phoneinfo.areaCode,
					phoneNumber: this.phoneinfo.phoneNumber
				},
				dateOfBirth: {
					year: this.in_buyerInfo.dateOfBirth.year,
					month: this.in_buyerInfo.dateOfBirth.month,
					day: this.in_buyerInfo.dateOfBirth.day
				},
				address: addressData
			}

			// save email to insert into the emt email input screen
			if(this.$gstate.getTxnType() == 'SELL'){
				this.$gstate.saveEmtEmailAddress(buyerInfo.emailAddress);
			}

			this.isProcessing = true;

			var urlstr = this.$gstate.getApiBaseURL() + '/buyerinfo';
			this.axios.post(urlstr, buyerInfo, this.$gstate.getAxiosHeaders())
				.then(response => {

					this.isProcessing = false;
					this.$gstate.saveBuyerInfo(buyerInfo);
					this.$gstate.saveFlowStateAndProceed(response.data, this);

				})
				.catch(error => {

					this.$gstate.log(error.response);
					
					this.isProcessing = false;
					this.hasError = true;
					this.showModal = true;

					if(Array.isArray(error.response.data)) {
						for (var index = 0; index < error.response.data.length; index++) { 
							this.modalErrorCode = error.response.data[index].errorCode;
							this.modalMessage = error.response.data[index].errorMsg;
						}
					} else if(error.response.data != undefined) {
						this.modalErrorCode = error.response.data.error.code;
						this.modalMessage = error.response.data.error.msg;
					} else {
						this.modalMessage = "Error saving your information.  Please try again.";
					}
					
					
				});
		},
		modalAction: function(action){

			if(action == "close"){
				this.showModal = false;
				if(this.modalErrorCode !== undefined){
					this.$root.DisableLeaveNotification();

					
					if (this.modalErrorCode == 'TRANSACTION.DAILYLIMIT.REACHED' || this.modalErrorCode == 'TRANSACTION.WEEKLYLIMIT.REACHED' || this.modalErrorCode == 'TRANSACTION.MONTLYLIMIT.REACHED'){
						this.$gstate.redirectHome(100, 0, 'Limit reached.');
					} else if (this.modalErrorCode == 'TRANSACTION.NOTFOUND'){
						this.$gstate.redirectHome(100, 0, 'Transaction not found.');
					} else if (this.modalErrorCode == 'TRANSACTION.INVALID'){
						this.$gstate.redirectHome(100, 0, 'Transaction invalid.');
					}
					
				}
			}
		},
		getTransaction(refId){

			// only executes if coming externally (e.g. Trezor)
			this.isProcessing = true;
			var urlstr = this.$gstate.getApiBaseURL() + '/status/' + refId;
			this.axios.get(urlstr)
				.then(response => {

					this.isProcessing = false;

					if(response.data.txnStatus == undefined || response.data.txnStatus != "PENDING"){
						this.hasError = true;
						this.showModal = true;
						this.modalErrorCode = 'TRANSACTION.INVALID';
						this.modalMessage = 'Transaction invalid';
						return;
					}

					var data = response.data;
					this.$gstate.saveFlowState(data);
					
					this.$emit('setRateHoldTimer', true);
					eventBus.$emit('updateTimer', data.txnValidUntil);

				})
				.catch(error => {
					
					this.isProcessing = false;
					this.hasError = true;
					this.showModal = true;
					this.modalErrorCode = error.response.data.error.code;
					this.modalMessage = error.response.data.error.msg;
					
				});
		}
	}
}
</script>
